import React, { useState } from "react";
import {
  Box,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Badge,
  Divider,
  ListItemIcon,
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LoginOutlined from "@mui/icons-material/LoginOutlined";
import Search from "./Search";

export default function NavbarMobile({
  cartCount = 0,
  showLogged = false,
  accountType = "",
  isActive,
  navigate,
  onLogin,
  onLogout,
  onAccount,
  hideLoginWhenLoggedOut = false,
}) {
  const [open, setOpen] = useState(false);
  const toggle = (v) => () => setOpen(v);

  const logged = !!showLogged;
  const accountLabel = accountType === "admin" ? "Panel administrativo" : "Mi Cuenta";

  const active = (path) => {
    return typeof isActive === "function" ? isActive(path) : false;
  };

  const handleNavigate = (path) => {
    navigate(path);
    setOpen(false);
  };

  const handleLogin = () => {
    setOpen(false);
    if (onLogin) onLogin();
  };

  const handleAccount = () => {
    setOpen(false);
    if (onAccount) onAccount();
  };

  const handleLogout = async () => {
    if (onLogout) await onLogout();
    setOpen(false);
  };

  return (
    <>
      <button className="menu-trigger" aria-label="Abrir menú" onClick={toggle(true)}>
        <MenuIcon />
        <span className="menu-word">MENÚ</span>
      </button>

      <Drawer anchor="left" open={open} onClose={toggle(false)}>
        <Box sx={{ width: 300 }} role="presentation">
          <Box className="drawer-top-icons">
            <IconButton
              aria-label="Carrito"
              onClick={() => handleNavigate("/shop")}
            >
              <Badge badgeContent={cartCount} color="error">
                <ShoppingCartIcon />
              </Badge>
            </IconButton>

            {!logged && !hideLoginWhenLoggedOut && (
              <IconButton aria-label="Iniciar sesión" onClick={handleLogin}>
                <LoginOutlined />
              </IconButton>
            )}
          </Box>

          <Divider />

          <List>
            <ListItemButton
              selected={active("/")}
              onClick={() => handleNavigate("/")}
              sx={{
                "&.Mui-selected": { backgroundColor: "#000" },
                "&.Mui-selected .MuiListItemText-primary": { color: "#ff6700" },
              }}
            >
              <ListItemText primary="Inicio" />
            </ListItemButton>

            <ListItemButton
              selected={active("/acerca-de-nosotros")}
              onClick={() => handleNavigate("/acerca-de-nosotros")}
              sx={{
                "&.Mui-selected": { backgroundColor: "#000" },
                "&.Mui-selected .MuiListItemText-primary": { color: "#ff6700" },
              }}
            >
              <ListItemText primary="Nosotros" />
            </ListItemButton>

            <ListItemButton
              selected={active("/servicios")}
              onClick={() => handleNavigate("/servicios")}
              sx={{
                "&.Mui-selected": { backgroundColor: "#000" },
                "&.Mui-selected .MuiListItemText-primary": { color: "#ff6700" },
              }}
            >
              <ListItemText primary="Servicios" />
            </ListItemButton>

            <ListItemButton
              selected={active("/categorias")}
              onClick={() => handleNavigate("/categorias")}
              sx={{
                "&.Mui-selected": { backgroundColor: "#000" },
                "&.Mui-selected .MuiListItemText-primary": { color: "#ff6700" },
              }}
            >
              <ListItemText primary="Tienda" />
            </ListItemButton>

            <ListItemButton
              selected={active("/contacto")}
              onClick={() => handleNavigate("/contacto")}
              sx={{
                "&.Mui-selected": { backgroundColor: "#000" },
                "&.Mui-selected .MuiListItemText-primary": { color: "#ff6700" },
              }}
            >
              <ListItemText primary="Contacto" />
            </ListItemButton>
          </List>

          {logged && (
            <>
              <Divider />
              <List>
                <ListItemButton onClick={handleAccount}>
                  <ListItemIcon>
                    <AccountCircleIcon />
                  </ListItemIcon>
                  <ListItemText primary={accountLabel} />
                </ListItemButton>

                <ListItemButton onClick={handleLogout}>
                  <ListItemText primary="Cerrar Sesión" />
                </ListItemButton>
              </List>
            </>
          )}
        </Box>
      </Drawer>
    </>
  );
}

export function MobileSearch() {
  return (
    <div className="nav-search mobile" style={{ width: "100%" }}>
      <Search isMobile />
    </div>
  );
}